import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <motion.footer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.6 }}
      className="mt-12 pt-8 pb-6 text-center border-t border-white/20"
    >
      <p className="text-slate-600 text-sm">
        <a 
          href="https://www.gospelwiseauthor.com" 
          target="_blank" 
          rel="noopener noreferrer"
          className="hover:underline transition-colors"
          style={{ color: '#ff8057' }}
        >
          Your writing journey starts here
        </a>
        {' • Made with ❤️ for Christian writers by '}
        <span className="font-semibold text-slate-700">CROSS + PEN</span>
      </p>
    </motion.footer>
  );
};

export default Footer;